import type { FaireProductEntity } from "../../entity_types/product";

export const p_n3yf4byyuh: FaireProductEntity = {
  token: "p_n3yf4byyuh",
  type: "product",
  name: "Vintage Desert - RECYCLED THROW BLANKET",
  brandToken: "b_3ltt834j6o",
  brandName: "Sundream",
  imageUrl:
    "https://cdn.faire.com/fastly/b870d44222a2e78b1c3a9488641f12174de835d581fa4ed4e021bcdee8d9440e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d2cd5b8f549e469f4bb5ef0e08d3b0bcc95ca5b196127e9242cda4e82f7316bf.jpeg",
    "https://cdn.faire.com/fastly/143dc3965bab25d24843c34e013787febbb6495bafd2916871b1d146d8d53f2d.jpeg",
    "https://cdn.faire.com/fastly/6acdb19ee22fbcc49ab1d33c257f7952c3492fa22477c6de7fe6363ee94888d1.jpeg",
    "https://cdn.faire.com/fastly/5bcca115a5e4f97c7304267a6f022b1e69b806a19e9461bd48b80c2e380ff682.jpeg",
    "https://cdn.faire.com/fastly/460b851e04cf1138b720a92771cbc6b3059da2884d255fa8d408a109494ad7c7.jpeg",
  ],
  priceDollars: 30,
  description:
    "Both beautiful and sustainable, these blankets are made of reclaimed fibers derived from 100% post-consumer materials containing a special blend of cotton, acrylic, and polyester.\n\nGreat for: \nRetail, resort, hotels, restaurants, corporate gifting\n\nThe Vintage Desert Style is designed to be be your go-to blanket - perfect for a home accent throw to cuddle up with & rugged enough for your weekend adventures up the coast! \n\nThis throw becomes softer (and you'll love it even more) after each wash.\n\nDesigned in California, Artisan made in Mexico.  \nTan Base, Yellow, Orange, Red, Navy + (Yellow Edge)\nMeasures 73 x 48\n\nMexican Blanket, Beach Blanket, Home Decor Blanket, Serape Blanket, Picnic Blanket, Outdoor Blanket, Yoga Blanket, eco-friendly, Up-cycled Material, Made in Mexico, Sustainably Made Throw Blanket, Turkish Towel, Sustainable Throw, Tapestry, Bed Throw, Picnic Blanket, Trending Now, Trending on Faire, Trend, Beach Throw, Woven Blanket, Woven Throw, Throw Pillows & Blankets, Summer, Western style, Vintage",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:40.020Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
